import { render, staticRenderFns } from "./PasswordLogin.vue?vue&type=template&id=5d25d542&scoped=true"
import script from "./PasswordLogin.vue?vue&type=script&lang=js"
export * from "./PasswordLogin.vue?vue&type=script&lang=js"
import style0 from "./PasswordLogin.vue?vue&type=style&index=0&id=5d25d542&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d25d542",
  null
  
)

export default component.exports